export default __webpack_public_path__ + "static/media/upload_file.9f70763f.svg";